import { Objectclass } from '@yes.technology/react-toolkit'

import { AssociatedUsersRelationsKeys } from 'site/Renderer/components/Kanban/Kanban.types'

import {
  AMFTaskCardConfiguration,
  ResolvedAMFTaskCardConfiguration
} from '../AMFTaskObjectCard.types'
import { DEFAULT_AMF_TASK_CARD_CONFIGURATION } from '../constants'

type ConfigurationArea = keyof ResolvedAMFTaskCardConfiguration

function resolveAreaKeys(
  keys: string[] | undefined,
  area: ConfigurationArea,
  objectclassFields?: Objectclass['fields']
): string[] {
  const defaults = [...DEFAULT_AMF_TASK_CARD_CONFIGURATION[area]]

  if (!keys?.length) {
    return defaults
  }

  const validKeys = keys.filter((key) => objectclassFields?.[key])

  if (!validKeys.length) {
    return defaults
  }

  return validKeys
}

export default function resolveCardConfiguration(
  config: AMFTaskCardConfiguration | undefined,
  objectclassFields?: Objectclass['fields']
): ResolvedAMFTaskCardConfiguration {
  return {
    process_information_area: resolveAreaKeys(
      config?.process_information_area,
      'process_information_area',
      objectclassFields
    ),
    associated_users_list: resolveAreaKeys(
      config?.associated_users_list,
      'associated_users_list',
      objectclassFields
    ) as AssociatedUsersRelationsKeys[],
    timestamps_area: resolveAreaKeys(
      config?.timestamps_area,
      'timestamps_area',
      objectclassFields
    )
  }
}
